export const backgroundColor = '#121E34'
export const containerColor = '#0D1626'
export const textColor = '#FFFFFF'
export const placeholderTextColor = '#2C4065'
export const gradColor = '#0540FF' //'linear-gradient(253.55deg, #6D53F9 6.18%, #F23CE3 99.93%)'
export const primaryColor = '#0540FF'
export const secondaryColor = '#FEF393'
export const tertiaryColor = '#F6CBFF'
export const upColor = '#4EFF8B'
export const downColor = '#FF2B5E'
export const transparentColor = '#FFFFFF00'
